import React from 'react';
import { PictoProps } from './index';

export const ArrowDown = (props: PictoProps) => (
  <svg
    width={props.width || '7'}
    height={props.height || '6'}
    viewBox="0 0 7 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.5 6L0.0358987 -6.52533e-07L6.9641 -4.68497e-08L3.5 6Z" fill={props.fill} />
  </svg>
);
